import { gatewayPhone } from "src/gateways/gatewayPhone";
import { CompanyNumberItem, GetNumbersQueryParams } from "../types";

/**
 * Fetches all company numbers from the VR-Assistant service (NumbersController)
 * Endpoint requires JwtAuthGuard on the backend.
 * Supports sorting filters: `order` ('ASC' | 'DESC') and `orderBy` (default: 'createdAt').
 */
export const getAllCompanyNumbers = async (params: GetNumbersQueryParams = { order: "DESC", orderBy: "createdAt" }): Promise<CompanyNumberItem[]> => {
  const { order = "DESC", orderBy = "createdAt" } = params;

  try {
    const res = await gatewayPhone.get("/company-numbers/all", {
      params: {
        order,
        orderBy,
      },
    });

    if (Array.isArray(res.data)) {
      return res.data.map((item: any) => ({
        id: item.uid || item.id,
        phoneNumber: item.phoneNumber || "",
        friendlyName: item.name || "Company Line",
        companyId: item.companyId || 0,
        companyName: item.companyName || `Company #${item.companyId || ""}`,
        status: (item.status || "active").toLowerCase(),
        source: item.source || "buying",
        provider: item.provider || "twilio",
        createdAt: item.createdAt || new Date().toISOString(),
        updatedAt: item.updatedAt || new Date().toISOString(),
      }));
    }
  } catch (error) {
    console.error("Error fetching company numbers from backend:", error);
  }

  return [];
};
